import { Action, createAction } from "@ngrx/store";
import { IEtudiantAdvanced, ITeacher } from "src/app/interfaces/etudiant";
import { StorageService } from "src/app/services/common/storage";

export const increment = createAction('[Counter Component] Increment');
export enum AuthActionTypes {
  LOGIN = '[Auth] Login',
  LOGIN_SUCCESS = '[Auth] Login Success',
  LOGIN_FAILURE = '[Auth] Login Failure',
  SIGNUP = '[Auth] Signup',


  LOGOUT = '[Auth] Logout'
}




//   export class LogIn implements Action {
//     readonly type = AuthActionTypes.LOGIN;
//     constructor(public payload: any) {}
//   }

export class LogInSuccess implements Action {
  readonly type = AuthActionTypes.LOGIN_SUCCESS;
  constructor(public payload: IEtudiantAdvanced | ITeacher, public localStorage: StorageService) { }
}

export class LogInFailure implements Action {
  readonly type = AuthActionTypes.LOGIN_FAILURE;
  constructor(public payload: IEtudiantAdvanced | ITeacher) { }
}

export class SignUp implements Action {
  readonly type = AuthActionTypes.SIGNUP;
  constructor(public payload: IEtudiantAdvanced | ITeacher) { }
}

export class LogOut implements Action {
  readonly type = AuthActionTypes.LOGOUT;
  constructor(public localStorage: StorageService) { }

}

export type All =
  // | LogIn
  | LogInSuccess
  | LogInFailure
  | SignUp
  | LogOut;